import { Box } from "@mui/material";
import i18next from "i18next";
import { useEffect } from "react";
import { WBTextType } from '../../../../constants/welcomeBonusTextTypes';

export const InvestorAnnouncementBar = ({ welcomeBonus = null }) => {

  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById("investor-announcement-bar");
      element.classList.remove("opacity-0"); // Remove the hidden state
      element.classList.add("opacity-100"); // Apply the fully visible state
    }, 200);
  }, []);

  return <Box id="investor-announcement-bar" className='min-h-[40px] opacity-0 transition-opacity duration-1000 md:py-2 p-2 text-center flex shadow-sm justify-center items-center secondary-bg !text-white !text-[14px] !font-[500]'>
    <Box>
      {welcomeBonus?.texts?.[`${WBTextType.signUpBanner}_${i18next.language}`]?.title ?
        <Box>
          <strong>{welcomeBonus?.texts?.[`${WBTextType.signUpBanner}_${i18next.language}`]?.title}</strong>
        </Box>
        : null}
      {welcomeBonus?.texts?.[`${WBTextType.signUpBanner}_${i18next.language}`]?.content ? <Box>
        <span>{welcomeBonus?.texts?.[`${WBTextType.signUpBanner}_${i18next.language}`]?.content}</span>
      </Box> : null}
    </Box>
  </Box>;
};